<div class="content">
  <div class="content-panel">
    <h2>Export des jurés</h2>

    <div class="p-2">
      <form [formGroup]="formFilter" (ngSubmit)="onExport()">
        <div class="row">
          <!-- Filtre college -->
          <div class="col-md-2">
            <div class="mb-3">
              <label for="college" class="form-check-label" translate>page.commissions.synthese-jure.search.college</label> :
              <select id="college" formControlName="college" class="form-select">
                <option [ngValue]="null">Tous</option>
                <option *ngFor="let college of colleges" [ngValue]="college">{{ college.libelle }}</option>
              </select>
            </div>
          </div>
          <!-- Filtre cahiers des charges -->
          <div class="col-md-2">
            <div class="mb-3">
              <label for="cahier" class="form-check-label" translate>page.commissions.synthese-jure.search.cahiers</label> :
              <app-multiselect id="cahier" controlName="cahier" [items]="cahiers" bindLabel="libelle" maxWidth="initial"></app-multiselect>
            </div>
          </div>
        </div>
        <!-- Bouton d'export -->
        <div class="actions-bar">
          <button type="submit" class="btn btn-primary ms-2 fit-content" translate>label.exporter</button>
        </div>
      </form>
    </div>
  </div>
</div>

